<script setup>
import { matchNavPath } from '@/utils/navActive';

const props = defineProps({ item: Object, level: Number });
const { t } = useI18n();
const route = useRoute();

const title = computed(() =>
  props.item?.titleKey ? t(props.item.titleKey) : props.item?.title || ''
);

const isHere = computed(() =>
  matchNavPath(props.item?.to, route.path, props.item?.exact === true)
);

function badgeTone(color) {
  const c = String(color || '').toLowerCase();
  if (c === 'warning' || c === 'orange' || c === 'amber') return 'warn';
  if (c === 'success' || c === 'teal' || c === 'green') return 'ok';
  if (c === 'info' || c === 'primary' || c === 'indigo' || c === 'blue') return 'info';
  return 'hot';
}
</script>

<template>
  <div class="mb-0">
    <v-list-item
      :href="item.external ? item.to : undefined"
      :to="!item.external ? item.to : undefined"
      :active="isHere"
      active-class="nav-is-active"
      :ripple="false"
      :disabled="item.disabled"
      :target="item.external === true ? '_blank' : undefined"
      class="nav-sublink"
      :class="{ 'nav-is-active': isHere }"
    >
      <template #prepend>
        <span class="nav-sublink__dot" aria-hidden="true" />
      </template>
      <v-list-item-title class="nav-sublink__title">{{ title }}</v-list-item-title>
      <v-list-item-subtitle
        v-if="item.subCaption"
        class="text-caption mt-n1 hide-menu"
      >
        {{ item.subCaption }}
      </v-list-item-subtitle>
      <template #append>
        <span v-if="isHere" class="nav-here-pip nav-here-pip--sub" aria-hidden="true" />
        <span
          v-if="item.chip"
          class="nav-badge"
          :class="'nav-badge--' + badgeTone(item.chipColor)"
          :title="item.chipTitle || t('nav.pendingCount', { n: item.chip })"
        >{{ item.chip }}</span>
      </template>
    </v-list-item>
  </div>
</template>

<style scoped>
.nav-here-pip--sub {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: #fff;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.35);
  margin-inline-start: 4px;
}
</style>
